module.exports = "/images/get-approved.png?3577709762238c4d03971f7b336d8c87";